import FuseNavigation from '@fuse/core/FuseNavigation';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { selectNavigation } from 'app/store/fuse/navigationSlice';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import { FuseNavigationProps } from '@fuse/core/FuseNavigation/FuseNavigation';
import { useLocation } from 'react-router';

/**
 * Navigation
 */
function Navigation(props: Partial<FuseNavigationProps>) {
	const { className = '', layout = 'vertical', dense, active } = props;

	const navigation = useAppSelector(selectNavigation);
	const { pathname } = useLocation();
	const isRecoverMode = pathname.includes('recover/start');

	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

	const dispatch = useAppDispatch();

	const displayNavigation = isRecoverMode
		? navigation.filter((item) => item.id !== 'adminDashboard')
		: navigation;

	return useMemo(() => {
		function handleItemClick() {
			if (isMobile) {
				dispatch(navbarCloseMobile());
			}
		}

		return (
			<FuseNavigation
				className={clsx('navigation flex-1', className)}
				navigation={displayNavigation}
				layout={layout}
				dense={dense}
				active={active}
				onItemClick={handleItemClick}
				checkPermission={!isRecoverMode}
			/>
		);
	}, [dispatch, isMobile, displayNavigation, active, className, dense, layout, isRecoverMode]);
}

export default Navigation;
